import { render, staticRenderFns } from "./pricing.vue?vue&type=template&id=01614027&scoped=true&"
import script from "./pricing.vue?vue&type=script&lang=js&"
export * from "./pricing.vue?vue&type=script&lang=js&"
import style0 from "./pricing.vue?vue&type=style&index=0&id=01614027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01614027",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PricingCards: require('/opt/build/repo/components/elements/PricingCards.vue').default,AppFeaturesComparison: require('/opt/build/repo/components/AppFeaturesComparison.vue').default,CallToAction: require('/opt/build/repo/components/elements/CallToAction.vue').default})
